import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { RootState } from 'model/state';
import { Dispatch } from 'redux';
import { AddBulkUnitsModal } from 'components';
import { createBulkUnits } from 'actions';
import { Location } from 'model';
import { selectIsSubmitting, selectAccountId } from 'selectors';

type SelectedValues = {
  isSubmitting: boolean,
  accountId?: string,
}

const mapStateToProps = createStructuredSelector<RootState, SelectedValues>({
  isSubmitting: selectIsSubmitting(),
  accountId: selectAccountId(),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  createBulkUnits: (unitNames: string[], parent: Location | null) => dispatch(createBulkUnits(unitNames, parent)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddBulkUnitsModal);
